module.exports = "<a href=\"http://www.usebenchmark.com/\">\r\n  <h1 class=\"login-logo icon-benchmark flush-icon\" [class.shake]=\"shakeLogo\">\r\n    <span class=\"sr-only\">Benchmark Intelligence</span>\r\n  </h1>\r\n</a>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login-logo/login-logo.html
// module id = 274
// module chunks = 1